<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on: dialog }">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn color="primary" large dark class="mb-2" v-on="{...dialog, ...tooltip}">
                        <v-icon>mdi-account-plus</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('users.register.hint') }}</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('users.register.label') }}</span>
            </v-card-title>

            <v-card-text>
                <v-form
                    ref="registerForm"
                    v-model="valid"
                    lazy-validation>
                    <v-text-field
                        :label="$t('users.email')"
                        :rules="rules.email"
                        v-model="user.email">
                    </v-text-field>

                    <v-text-field
                        :label="$t('users.forename')"
                        v-model="user.forename">
                    </v-text-field>

                    <v-text-field
                        :label="$t('users.surname')"
                        v-model="user.surname">
                    </v-text-field>

                    <v-text-field
                        v-model="user.password"
                        :label="$t('users.password')"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="rules.password"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword">
                    </v-text-field>

                    <v-select
                        v-model="user.role"
                        :items="roles.list"
                        :rules="rules.required"
                        item-text="label"
                        item-value="value"
                        :label="$t('users.role')">
                    </v-select>
                </v-form>

                <v-form
                    v-if="this.user.role === roles.PARTNER"
                    ref="companyForm"
                    v-model="companyValid"
                    lazy-validation>
                    <v-subheader>{{ $t('users.register.company.section') }}</v-subheader>
                    <v-text-field
                        :label="$t('company.name')"
                        :rules="rules.required"
                        v-model="company.name">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.nip')"
                        v-model="company.nip">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.address')"
                        v-model="company.address">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.phone')"
                        v-model="company.phone">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.account')"
                        v-model="company.account">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.payment')"
                        v-model="company.payment">
                    </v-text-field>
                    <v-text-field
                        :label="$t('company.contact')"
                        v-model="company.contact">
                    </v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-progress-circular v-if="registering" indeterminate></v-progress-circular>
                <v-btn :disabled="registering || !valid" color="blue darken-1" text
                       @click="register">{{ $t('users.register.submit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import roles from '@/helpers/users/roles'

    export default {
        name: "Register",
        computed: {
            roles() {
                return roles
            }
        },
        props: ['rules'],
        data() {
            return {
                valid: false,
                companyValid: false,
                dialog: false,
                showPassword: false,
                user: {
                    email: "",
                    forename: "",
                    surname: "",
                    role: "",
                    password: ""
                },
                registering: false,
                company: {}
            }
        },
        methods: {
            register() {
                if(this.user.role === this.roles.PARTNER) {
                    if(this.$refs.registerForm.validate() && this.$refs.companyForm.validate()) {
                        this.addCompany()
                            .then(({ data }) => {
                                this.user.company_id = data.id
                                this.addUser()
                            })
                            .catch(() => {
                                this.$emit("result", {
                                    message: this.$t('users.register.company.fail'),
                                    color: 'error'
                                })
                            })
                    }
                } else if (this.$refs.registerForm.validate()) {
                    this.user.company_id = 1
                    this.addUser()
                }
            },
            addCompany() {
                return this.$http.post('company', this.company)
            },
            addUser() {
                this.$http.post('auth/register', this.user)
                    .then(() => {
                        this.$emit("reload")
                        this.dialog = false
                        this.$emit("result", {
                            message: this.$t('users.register.done'),
                            color: 'success'
                        })
                        this.refresh()
                    })
                    .catch(() => {
                        this.dialog = false
                        this.$emit("result", {
                            message: this.$t('users.register.fail'),
                            color: 'error'
                        })
                    })
            },
            refresh() {
                this.user = {
                    email: "",
                    role: "user",
                    password: ""
                }
                this.company = {
                    name: "",
                    nip: "",
                    phone: "",
                    address: "",
                    account: "",
                    payment: "",
                    contact: ""
                }
            }
        },
        mounted() {
            this.refresh()
        }
    }
</script>

<style scoped>

</style>
